import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { blogData } from "../../utils/blogData";

const BlogComponent = () => {
  return (
    <section className="blog-section py-100 pb-5">
      <Container>
        <Row className="justify-content-center mb-5 pt-60">
          <Col md={8} className="text-center">
            <span className="about-badge mb-3">Latest Updates</span>
            <h2 className="banner-title mb-3" style={{ fontSize: "3rem" }}>
              Our <span className="gradient-text pb-2">Blog & Insights</span>
            </h2>
            <p className="about-description">
              Stay updated with the latest trends, expert insights, and success stories 
              from the world of technology and digital innovation.
            </p>
          </Col>
        </Row>
        <Row>
          {blogData.map((blog) => (
            <Col lg={4} md={6} key={blog.id} className="mb-4">
              <div className="blog-card h-100 d-flex flex-column">
                <div className="card-img-wrapper">
                  <span className="blog-date-badge">
                    <i className="far fa-calendar-alt me-2"></i>
                    {blog.date}
                  </span>
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                  />
                </div>
                <div className="blog-content d-flex flex-column flex-grow-1">
                  <div className="blog-meta-item">
                    <i className="far fa-user"></i>
                    <span>{blog.author}</span>
                  </div>
                  
                  <h3 className="blog-title">
                    <Link to={`/blog-details/${blog.id}`}>
                      {blog.title}
                    </Link>
                  </h3>
                  
                  <p className="blog-excerpt">
                    {blog.excerpt}
                  </p>
                  
                  <div className="mt-auto pt-3">
                    <Link to={`/blog-details/${blog.id}`} className="read-more-btn">
                      Read Full Article <i className="fas fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BlogComponent;
